export default __webpack_public_path__ + "static/media/archive.73e84cc4.svg";